<template>
  <div id="news-ipos-container" class="news-ipos-container">
    <PageHeader 
      v-if="has_ipo_permissions"
      title="Próximas IPOs"
      subtitle="Encuentra valores interesantes que han salido a bolsa recientemente o lo harán pronto."
    />

    <div v-if="has_ipo_permissions">
      <div>
        <div class="filters-card card">
          <h3 class="typo-headline-6 section-title">Filtros de Búsqueda</h3>
          <div class="filters-grid">
            <div class="form-group">
              <label for="ipo-name-filter">Nombre de Empresa</label>
              <input 
                type="text" 
                id="ipo-name-filter" 
                class="form-input" 
                v-model="filter_name_str"
                placeholder="Ej: Acme Corp"
              />
            </div>
            <div class="form-group" v-if="_g_UserFeatures.permissions.next_IPOs_mundial">
              <label for="ipo-country-filter">País</label>
              <select id="ipo-country-filter" class="form-select" v-model="filter_country_val">
                <option v-for="option in options_mundial" :key="option.name" :value="option.name">{{ option.value }}</option>
              </select>
            </div>
            <div class="form-group" v-else-if="_g_UserFeatures.permissions.next_IPOs_euro_zone">
              <label for="ipo-country-filter-euro">País (Eurozona)</label>
              <select id="ipo-country-filter-euro" class="form-select" v-model="filter_country_val">
                <option v-for="option in options_euro" :key="option.name" :value="option.name">{{ option.value }}</option>
              </select>
            </div>
            <div class="form-group" v-else-if="_g_UserFeatures.permissions.next_IPOs_usa_zone">
              <label for="ipo-country-filter-usa">País (USA/Canadá)</label>
              <select id="ipo-country-filter-usa" class="form-select" v-model="filter_country_val">
                <option v-for="option in options_usa" :key="option.name" :value="option.name">{{ option.value }}</option>
              </select>
            </div>
            <button class="button button-primary" @click="_triggerSearch">Buscar IPOs</button>
          </div>
        </div>

        <div class="results-summary card">
            <span class="typo-body-1">{{ results_message }}</span>
        </div>

        <div class="info-callout card">
          <img class="info-icon" src="@/features/market-tools/assets/blue-info.png" alt="Información">
          <p class="typo-body-2">
            Los valores que aquí se muestran son aquellos que saldrán al mercado próximamente o que lo hicieron hace menos de 6 meses. Ten en cuenta que estos valores no necesariamente cumplen con la metodología Eurekers en su totalidad en el momento de su salida.
          </p>
        </div>

        <TableCustom 
          :table_header="table_header" 
          :table_body="table_body_prepared" 
          v-if="table_body_prepared.length > 0"
          dynamicHeight="auto"
          maxBodyHeight="60vh"
        />
        <p v-if="!table_body_prepared.length && ipos_raw" class="typo-body-1 no-results-message card">
            No se encontraron IPOs con los filtros seleccionados.
        </p>

      </div>
    </div>

    <ToolAccessState
      v-else-if="_g_HasAppSession"
      title="Próximas IPOs no incluidas"
      message="Tu plan actual no incluye acceso a próximas IPOs."
    />

    <ToolAccessState
      v-else
      title="Próximas IPOs"
      message="Inicia sesión para acceder a próximas IPOs."
      anonymous
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import APICaller from "@/shared/mixins/APICaller.js";
import TableCustom from "@/shared/components/ui/Table_news_ipos.vue";
import PageHeader from "@/shared/components/common/PageHeader.vue";
import ToolAccessState from "@/shared/components/common/ToolAccessState.vue";

export default {
  mixins: [APICaller],
  name: 'NewsIPOsPage',
  components: {
    TableCustom,
    PageHeader,
    ToolAccessState,
  },
  metaInfo() {
    return {
      title: 'Próximas IPOs Eurekers',
      meta: [
        { name: 'description', content: "Encuentra IPOs interesantes y empresas prometedoras que saldrán a bolsa próximamente con Eurekers." }
      ]
    }
  },
  data() {
    return {
      ipos_raw: null,
      table_header: ["Ticker", "Empresa", "Fecha Publicación"],
      filter_name_str: "",
      filter_country_val: "0",
      options_mundial: [
        { name: "0", value: "Todos los Países" },
        { name: "AX", value: "Australia" },
        { name: "TO", value: "Canadá" },
        { name: "SS", value: "China" },
        { name: "L", value: "Inglaterra" },
        { name: "PA", value: "Francia" },
        { name: "DE", value: "Alemania" },
        { name: "HK", value: "Hong Kong" },
        { name: "OL", value: "Noruega" },
        { name: "KQ", value: "Corea del Sur" },
        { name: "ST", value: "Suecia" },
        { name: "TW", value: "Taiwán" },
        { name: "", value: "EE.UU." }
      ],
      options_euro: [
        { name: "L", value: "Inglaterra" },
        { name: "PA", value: "Francia" },
        { name: "DE", value: "Alemania" },
      ],
      options_usa: [
        { name: "TO", value: "Canadá" },
        { name: "", value: "EE.UU." }
      ],
    };
  },
  computed: {
    ...mapGetters(["_g_HasAppSession", "is_mobile_device", "_g_User", "_g_UserFeatures"]),
    
    has_ipo_permissions() {
      if (!this._g_UserFeatures || !this._g_UserFeatures.permissions) return false;
      return this._g_UserFeatures.permissions.next_IPOs_euro_zone || 
             this._g_UserFeatures.permissions.next_IPOs_usa_zone || 
             this._g_UserFeatures.permissions.next_IPOs_mundial;
    },

    table_body_prepared() {
      if (!this.ipos_raw || this.ipos_raw.length === 0) return [];
      return this.ipos_raw.map(element => {
        let ticker = element.data[0].data;
        if (ticker.includes("<") && ticker.includes(">")) {
            const match = ticker.match(/>(.*?)</);
            if (match && match[1]) ticker = match[1];
        }
        const empresa = element.data[1].data;
        const fecha = element.data[2].data;
        return [ticker, empresa, fecha];
      });
    },
    results_message(){
        if (this.ipos_raw === null) {
            return "Cargando IPOs...";
        }
        if(this.ipos_raw.length > 0){
            return `${this.ipos_raw.length} ${this.ipos_raw.length === 1 ? 'valor encontrado' : 'valores encontrados'}.`;
        }
        return "Búsqueda completada.";
    }
  },
  watch: {
    has_ipo_permissions(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultCountryFilter();
        this._fetchIPOs();
      }
    }
  },
  mounted() {
    if (this.has_ipo_permissions) {
      this.setDefaultCountryFilter();
      this._fetchIPOs();
    }
  },
  methods: {
    setDefaultCountryFilter(){
      if (this._g_UserFeatures.permissions.next_IPOs_mundial) {
        this.filter_country_val = '0';
      } else if (this._g_UserFeatures.permissions.next_IPOs_euro_zone) {
        this.filter_country_val = 'L';
      } else if (this._g_UserFeatures.permissions.next_IPOs_usa_zone) {
        this.filter_country_val = "";
      }
    },
    _redirectToLogin() {
      window.location.href = "/user/login";
    },
    _fetchIPOs() {
      this.ipos_raw = null;
      let success = (response) => {
        let raw_data = response.data || [];
        if (raw_data.length > 0 && Array.isArray(raw_data[0]) && raw_data[0].length > 0 && typeof raw_data[0][0] === 'string' && raw_data[0][0].toLowerCase().includes('ticker')) {
          raw_data.shift();
        }
        
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        const sixMonthsAgoTimestamp = sixMonthsAgo.getTime();

        this.ipos_raw = raw_data.filter(element => {
            if(!element.data || !element.data[2] || !element.data[2].data) return false;
            let dateStr = element.data[2].data;
            const parts = dateStr.split("-");
            if (parts.length !== 3) return false;
            const formattedDateStr = `${parts[2]}-${parts[1]}-${parts[0]}`;
            const ipoDate = new Date(formattedDateStr);
            if (isNaN(ipoDate.getTime())) return false;
            return ipoDate.getTime() >= sixMonthsAgoTimestamp;
        });
      };
      let failure = () => {
        this.ipos_raw = [];
      };

      const url = `/api/v1/valores/ipos?name=${encodeURIComponent(this.filter_name_str)}&country=${encodeURIComponent(this.filter_country_val)}`;
      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('NEWS-IPOS-FETCH', 'Error recuperando IPOs.', failure);
      this._getAPICall(url, successHandler, failureHandler);
    },
    _triggerSearch() {
      this._fetchIPOs();
    },
  }
}
</script>

<style lang="scss" scoped>
.news-ipos-container {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  padding: 20px 5%;
  min-height: 100vh;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.card {
  background-color: var(--color-surface);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
  padding: 25px 30px;
  margin-bottom: 30px;
  border: 1px solid var(--color-outline);
}

.section-title {
  color: var(--color-text-primary);
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline-variant);
}

.filters-card {
  .filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    align-items: end;
  }
  .button-primary {
    height: 46px;
    align-self: end;
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  label {
    margin-bottom: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--color-text-secondary);
  }
}

.form-input,
.form-select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--color-outline);
  border-radius: 6px;
  background-color: var(--color-input-background, var(--color-surface));
  color: var(--color-text-primary);
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
  height: 46px;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px var(--color-primary-alpha, rgba(15, 174, 215, 0.25));
  }
  &::placeholder { color: var(--color-text-placeholder, var(--color-text-inactive)); opacity: 0.7; }
}

.form-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23333'%3E%3Cpath d='M8 11.207l-4.66-4.66a.5.5 0 0 1 .707-.707L8 9.793l4.053-4.053a.5.5 0 1 1 .707.707L8 11.207z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 16px 16px;
  padding-right: 40px;
}

.button {
  padding: 12px 25px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.1s ease;
  border: 1px solid transparent;
  text-align: center;
  display: inline-block;
  width: auto;

  &.button-primary {
    background-color: var(--color-highlight);
    color: var(--color-text-on-highlight, #fff);
    border-color: var(--color-highlight);
    &:hover { background-color: var(--color-primary-dark, hsl(195, 95%, 40%)); border-color: var(--color-primary-dark, hsl(195, 95%, 40%)); }
    &:active { transform: translateY(1px); }
  }
  &.button-secondary {
    background-color: transparent;
    color: var(--color-primary);
    border-color: var(--color-primary);
    &:hover { background-color: var(--color-primary-alpha, rgba(15,174,215,0.1)); }
  }
}

.results-summary {
  padding: 15px 20px;
  text-align: center;
  .typo-body-1 {
    font-weight: 500;
  }
}

.info-callout {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  background-color: var(--color-info-background, #d9edf7);
  border: 1px solid var(--color-info-border, #bce8f1);
  color: var(--color-info-text, #31708f);
  padding: 15px 20px;
  .info-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-top: 2px;
  }
  .typo-body-2 {
    line-height: 1.6;
  }
}

.no-results-message.card {
    padding: 30px;
    text-align: center;
    color: var(--color-text-secondary);
    margin-top: 0;
}

.no-access-card, .login-prompt-card {
  text-align: center;
  padding: 40px 30px;
  .typo-headline-5 {
    margin-bottom: 15px;
  }
  .typo-body-1 {
    margin-bottom: 25px;
    color: var(--color-text-secondary);
  }
  .promo-image {
    max-width: 100%;
    height: auto;
    max-height: 250px;
    border-radius: 8px;
    margin-bottom: 20px;
    object-fit: cover;
  }
  .button {
      width: auto;
      min-width: 180px;
  }
}

.typo-headline-5 { font-size: 1.5rem; font-weight: 500; line-height: 1.3; }
.typo-headline-6 { font-size: 1.25rem; font-weight: 500; line-height: 1.4; }
.typo-body-1 { font-size: 1rem; line-height: 1.6; }
.typo-body-2 { font-size: 0.875rem; line-height: 1.5; }

@media (max-width: 768px) {
  .filters-card .filters-grid {
    grid-template-columns: 1fr;
    .button-primary {
        width: 100%;
    }
  }
  .info-callout {
    flex-direction: column;
    align-items: center;
    text-align: center;
    .info-icon { margin-bottom: 10px; }
  }
}

@media (max-width: 600px) {
  .news-ipos-container {
    padding: 15px;
  }
  .card {
    padding: 20px 25px;
  }
  .login-prompt-card .promo-image {
      max-height: 200px;
  }
}

</style>
